import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import { VireonLogoIcon } from './VireonLogoIcon';
import { cn } from '../../lib/cn';

// Inline SVG for Font Awesome faSun (Solid)
export const SunIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 512 512"
    className={cn("w-4.5 h-4.5 fill-current", className)}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M361.5 1.2c5.03 2.1 8.63 6.6 9.62 11.9L391 121l107.9 19.8c5.3.97 9.8 4.6 11.9 9.6 2.1 5 1.5 10.7-1.6 15.2L446 256l63.2 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391l-19.9 107.9c-1 5.3-4.6 9.8-9.62 11.9-5.01 2.1-10.7 1.5-15.18-1.6L256 446l-90.3 63.2c-4.48 3.1-10.17 3.7-15.18 1.6-5.02-2.1-8.62-6.6-9.62-11.9L121 391 13.1 371.2c-5.3-.97-9.8-4.6-11.9-9.6-2.1-5-1.5-10.7 1.6-15.2L66 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121l19.9-107.9c1-5.3 4.6-9.8 9.62-11.9 5.01-2.1 10.7-1.5 15.18 1.6L256 66l90.3-63.2c4.48-3.1 10.17-3.7 15.18-1.6zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z" />
  </svg>
);

// Inline SVG for Font Awesome faMoon (Solid)
export const MoonIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 384 512"
    className={cn("w-4.5 h-4.5 fill-current", className)}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M223.5 32C100 32 0 132.3 0 256s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.4-.5-12.7-.8-19-.8z" />
  </svg>
);

interface ThemeButtonProps {
  className?: string;
}

export const ThemeButton: React.FC<ThemeButtonProps> = ({ className }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className={cn(
        'relative w-9 h-9 grid place-items-center rounded-full overflow-hidden',
        'bg-ink-100/80 border border-ink-200/70 text-ink-600',
        'active:scale-95 transition-colors transition-shadow duration-200 ease-out shadow-card',
        'floating-action-btn',
        className
      )}
    >
      <span
        className={cn(
          'absolute inset-0 grid place-items-center transition-[opacity,transform] duration-200 ease-out',
          theme === 'light' ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
        )}
        aria-hidden="true"
      >
        <SunIcon className="w-[15px] h-[15px] text-amber-500" />
      </span>
      <span
        className={cn(
          'absolute inset-0 grid place-items-center transition-[opacity,transform] duration-200 ease-out',
          theme === 'dark' ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
        )}
        aria-hidden="true"
      >
        <MoonIcon className="w-[14px] h-[14px] text-blue-400" />
      </span>
      <span
        className={cn(
          'absolute inset-0 grid place-items-center transition-[opacity,transform] duration-200 ease-out',
          theme === 'vir' ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
        )}
        aria-hidden="true"
      >
        <div className="w-[20px] h-[20px] grid place-items-center text-[#B87445]">
          <VireonLogoIcon size={20} />
        </div>
      </span>
    </button>
  );
};
